"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const shared_1 = require("../../../shared");
const SpacerDynamic = (props) => {
    const { vSpace = 0, hSpace = 0 } = props;
    return (react_1.default.createElement(react_native_1.View, { style: { height: shared_1.dynamicHeight(vSpace), width: shared_1.dynamicWidth(hSpace) } }));
};
exports.default = react_1.default.memo(SpacerDynamic);
